import { render, staticRenderFns } from "./create-client-modal.vue?vue&type=template&id=4ae88a54&scoped=true"
import script from "./create-client-modal.vue?vue&type=script&lang=js"
export * from "./create-client-modal.vue?vue&type=script&lang=js"
import style0 from "./create-client-modal.vue?vue&type=style&index=0&id=4ae88a54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae88a54",
  null
  
)

export default component.exports